import { render, staticRenderFns } from "./full-product-card.vue?vue&type=template&id=70030c2c&"
import script from "./full-product-card.vue?vue&type=script&lang=ts&"
export * from "./full-product-card.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports